import { render, staticRenderFns } from "./taskdetail.vue?vue&type=template&id=46644bd3&scoped=true&"
import script from "./taskdetail.vue?vue&type=script&lang=js&"
export * from "./taskdetail.vue?vue&type=script&lang=js&"
import style0 from "./taskdetail.vue?vue&type=style&index=0&id=46644bd3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46644bd3",
  null
  
)

export default component.exports